import styled from 'styled-components'

export const AccountContainer = styled.div`
`